export var App;
(function (App) {
    App["CONTENT"] = "content";
})(App || (App = {}));
export var Pages;
(function (Pages) {
    Pages["PROFILE"] = "Profile";
    Pages["NOT_FOUND"] = "NotFound";
    Pages["SIGNIN"] = "SignIn";
    Pages["SIGNUP"] = "SignUp";
})(Pages || (Pages = {}));
export var Steps;
(function (Steps) {
    Steps["PERSONAL_DETAILS"] = "personaldetailsstep";
    Steps["PERSONAL_DETAILS_TWO"] = "personaldetailssteptwo";
})(Steps || (Steps = {}));
export var Actions;
(function (Actions) {
    Actions["FETCH_CONTENT"] = "FETCH_CONTENT";
    Actions["FETCH_PROFILE_CONTENT"] = "FETCH_PROFILE_CONTENT";
    Actions["FETCH_STEP_DATA"] = "FETCH_STEP_DATA";
    Actions["FETCH_SCOPE_DATA"] = "FETCH_SCOPE_DATA";
    Actions["SEND_FORM_DATA"] = "SEND_FORM_DATA";
    Actions["LOGIN"] = "LOGIN";
    Actions["CREATE_ACCOUNT"] = "CREATE_ACCOUNT";
    Actions["GET_COOKIE_FROM_TOKEN"] = "GET_COOKIE_FROM_TOKEN";
    Actions["GET_TOKEN_SILENT"] = "GET_TOKEN_SILENT";
    Actions["SET_CONNECT_ID"] = "SET_CONNECT_ID";
})(Actions || (Actions = {}));
export var Mutations;
(function (Mutations) {
    Mutations["SET_STEP_DATA"] = "SET_STEP_DATA";
    Mutations["SET_PROFILE_CONTENT"] = "SET_PROFILE_CONTENT";
    Mutations["SET_USER_FIRST_NAME_VALUE"] = "SET_USER_FIRST_NAME_VALUE";
    Mutations["SET_USER_FAMILY_NAME_VALUE"] = "SET_USER_FAMILY_NAME_VALUE";
    Mutations["SET_USER_OTHER_NAMES_VALUE"] = "SET_USER_OTHER_NAMES_VALUE";
    Mutations["SET_USER_TITLE_VALUE"] = "SET_USER_TITLE_VALUE";
    Mutations["SET_USER_MOBILE_NUMBER_VALUE"] = "SET_USER_MOBILE_NUMBER_VALUE";
    Mutations["SET_USER_ALTERNATIVE_NUMBER_VALUE"] = "SET_USER_ALTERNATIVE_NUMBER_VALUE";
    Mutations["SET_FORM_API_LOADING"] = "SET_FORM_API_LOADING";
    Mutations["SET_FORM_DATA"] = "SET_FORM_DATA";
    Mutations["SET_FORM_API_ERROR"] = "SET_FORM_API_ERROR";
    Mutations["SET_AUTH_DATA"] = "SET_AUTH_DATA";
    Mutations["SET_IS_AUTHENTICATED"] = "SET_IS_AUTHENTICATED";
    Mutations["SET_CONTENT"] = "SET_CONTENT";
})(Mutations || (Mutations = {}));
export var ResponseStatusCodes;
(function (ResponseStatusCodes) {
    ResponseStatusCodes[ResponseStatusCodes["OK"] = 200] = "OK";
    ResponseStatusCodes[ResponseStatusCodes["CREATED"] = 201] = "CREATED";
    ResponseStatusCodes[ResponseStatusCodes["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    ResponseStatusCodes[ResponseStatusCodes["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    ResponseStatusCodes[ResponseStatusCodes["NOT_FOUND"] = 404] = "NOT_FOUND";
    ResponseStatusCodes[ResponseStatusCodes["CONFLICT"] = 409] = "CONFLICT";
    ResponseStatusCodes[ResponseStatusCodes["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
})(ResponseStatusCodes || (ResponseStatusCodes = {}));
